import {Component, Input} from '@angular/core';
import {OrdersSuccessData} from "../../../../interfaces/orders-success-data";

@Component({
  selector: 'app-message-delivery-brojko-confirm',
  templateUrl: './message-delivery-brojko-confirm.component.html',
  styleUrls: ['./message-delivery-brojko-confirm.component.scss']
})
export class MessageDeliveryBrojkoConfirmComponent {
  @Input() deliveryCurrent;

  public data: OrdersSuccessData;

  public isDeliveryBrojkoConfirmation: boolean = false;
  deliveryBrojkoConfirmationShow(data: OrdersSuccessData) {
    this.data = data;
    this.isDeliveryBrojkoConfirmation = true;
  }

  protected readonly parseFloat = parseFloat;
}
